import { Swiper } from 'dingtalk-design-mobile'
import './CulturePalace.less'
import { memo, useCallback, useState } from 'react'
import Tabs from '@/components/Tabs'
import useHistory from '@/hooks/useHistory'
import dd from "@/utils/dd.config"

const CulturePalace = () => {
  const history = useHistory()

  const [bannerList, setBannerList] = useState([
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/banner-01.png',
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/banner-02.png',
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/banner-03.png',
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/banner-04.png',
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/banner-05.png',
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/banner-06.png',
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/banner-07.png',
  ])
  const [list, setList] = useState([
    {id: '01', src: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/list-01.png',},
    {id: '02', src: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/list-02.png',},
    {id: '03', src: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/list-03.png',},
    {id: '04', src: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/list-04.png',},
    {id: '05', src: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/list-05.png',},
  ])
  const [sidebarActive, setSidebarActive] = useState(1)
  const tabs = [{
    title: '简介',
    key: 1
  }, {
    title: '导览图',
    key: 2
  }, {
    title: '文化宫活动',
    key: 3
  }, {
    title: '室场预约',
    key: 4
  }]

  const sidebarTabs = [{
    key: 1,
    title: '文化宫1F',
    imgs: [{
      name: '荣誉展厅',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-1-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-1-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-1-2.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-1-3.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-1-4.jpg'
      ]
    }, {
      name: '城市展厅',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-2-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-2-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-2-2.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-2-3.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-2-4.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-2-5.jpg'
      ]
    }, {
      name: '多功能报告厅',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-3-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-3-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-3-2.jpg',
      ]
    }, {
      name: '接待室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-4-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-4-1.jpg',
      ]
    }, {
      name: '户外劳动者工会爱心驿站',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-5-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-5-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/1-5-2.jpg',
      ]
    }]
  }, {
    key: 2,
    title: '文化宫2F',
    imgs: [{
      name: '书画室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-1-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-1-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-1-2.jpg',
      ]
    }, {
      name: '琴棋室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-2-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-2-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-2-2.jpg',
      ]
    }, {
      name: '音乐室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-3-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-3-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-3-2.jpg',
      ]
    }, {
      name: '烘焙教学区',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-4-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-4-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-4-2.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-4-3.jpg',
      ]
    }, {
      name: '健身舞蹈室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-5-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-5-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-5-2.jpg',
      ]
    }, {
      name: '普拉提瑜伽室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-6-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-6-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-6-2.jpg',
      ]
    }, {
      name: '职工心灵驿站',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-7-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-7-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-7-2.jpg',
      ]
    }, {
      name: '爱心妈妈小屋',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-8-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-8-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/2-8-2.jpg',
      ]
    }]
  }, {
    key: 3,
    title: '文化宫3F',
    imgs: [{
      name: '职工健康疗养院',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-1-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-1-1.jpg',
      ]
    }, {
      name: '职工休闲服务区',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-2-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-2-1.jpg',
      ]
    }, {
      name: '香山幸福食堂',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-3-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-3-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-3-2.jpg',
      ]
    }, {
      name: '多功能活动室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-4-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-4-1.jpg',
      ]
    }, {
      name: '健身舞蹈室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-5-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/3-5-1.jpg',
      ]
    }]
  }, {
    key: 4,
    title: '文化宫4F',
    imgs: [{
      name: '职工书屋',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-1-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-1-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-1-2.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-1-3.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-1-4.jpg',
      ]
    }, {
      name: '电子阅览室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-2-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-2-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-2-2.jpg',
      ]
    }, {
      name: '青少年阅读室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-3-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-3-1.jpg',
      ]
    }, {
      name: '儿童阅读区',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-4-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-4-1.jpg'
      ]
    }, {
      name: '餐吧',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-5-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-5-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-5-2.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-5-3.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/4-5-4.jpg',
      ]
    }]
  }, {
    key: 5,
    title: '文化宫5F',
    imgs: [{
      name: '职工思政基地',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-1-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-1-1.jpg',
      ]
    }, {
      name: '职工学堂',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-2-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-2-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-2-2.jpg',
      ]
    }, {
      name: '职工大舞台',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-3-1.jpg',
      urls: ['http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-3-1.jpg']
    }, {
      name: '乒乓球室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-4-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-4-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-4-2.jpg',
      ]
    }, {
      name: '羽毛球场',
      url: '',
      urls: []
    }, {
      name: '办公室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-6-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-6-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-6-2.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-6-3.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-6-4.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-6-5.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-6-6.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-6-7.jpg',
      ]
    }, {
      name: '军旅展馆',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-7-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-7-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-7-2.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/5-7-3.jpg',
      ]
    }]
  }, {
    key: 6,
    title: '文化宫6F',
    imgs: [{
      name: '职工创新创业基地',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-1-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-1-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-1-2.jpg',
      ]
    }, {
      name: '职工培训中心',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-2-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-2-1.jpg',
      ]
    }, {
      name: '多媒体培训教育室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-3-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-3-1.jpg',
      ]
    }, {
      name: '职工健身区',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-4-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-4-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-4-2.jpg',
      ]
    }, {
      name: '职工休闲区',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-5-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-5-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-5-2.jpg',
      ]
    }, {
      name: '台球区',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-6-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-6-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-6-2.jpg',
      ]
    }, {
      name: '办公室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-7-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-7-1.jpg',
      ]
    }, {
      name: '会议室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-8-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/6-8-1.jpg',
      ]
    }]
  }, {
    key: 7,
    title: '文化宫7F',
    imgs: [{
      name: '职工影院(香山区 紫马厅 金龙厅)',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-2.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-3.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-4.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-5.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-6.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-7.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-8.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-1-9.jpg',
      ]
    }, {
      name: '职工舞台剧场',
      url: '',
      urls: []
    }, {
      name: '多功能厅',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-2-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/7-2-1.jpg',
      ]
    }]
  }, {
    key: 8,
    title: '文化宫8F',
    imgs: [{
      name: '职工服务中心/工会法律服务站',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-1-1.jpg',
      urls: ['http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-1-1.jpg']
    }, {
      name: '工会法律服务站',
      url: '',
      urls: []
    }, {
      name: '劳动争议调解室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-3-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-3-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-3-2.jpg',
      ]
    }, {
      name: '信息中心',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-4-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-4-1.jpg',
      ]
    }, {
      name: '办公室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-5-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-5-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-5-2.jpg',
      ]
    }, {
      name: '会议室',
      url: 'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-6-1.jpg',
      urls: [
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-6-1.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-6-2.jpg',
        'http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/8-6-3.jpg',
      ]
    }]
  }]

  const handleClick = useCallback((id) => {
    history.push('/CulturePalaceDetail?id=' + id)
  }, [])

  const handleChangeActive = useCallback((key) => {
    setSidebarActive(key)
  }, [])

  const handlePreview = useCallback(item => {
    dd.previewImage(item.urls, 0)
  }, [])
  return (
    <div className='pg-culture-palace'>
      <Tabs tabs={tabs} >
        <div key={1}>
          <Swiper className='pg-culture-palace-banner'>
            {
              bannerList.map((item, index) => {
                return <Swiper.Item key={index}>
                  <img className='banner-img' src={ item } />
                </Swiper.Item>
              })
            }
          </Swiper>
          <div className='pg-culture-palace-container'>
            <div className='title'>东区街道工人文化宫</div>
            <div>
              <div className='content'>东区街道工人文化宫建于2023年，位于中山市孙文东路268号御景湾大厦，总建筑面积6446.76㎡，主体大楼共八层，由广东省总工会、中山市总工会、东区街道办事处和东区街道总工会四级共同投资推动建设，是中山市首个建成启用的镇街工人文化宫。东区街道工人文化宫地理位置优越、服务设施齐全、环境优美舒适，内设书画室、音乐室、烘焙区、健身舞蹈室、乒乓球室、羽毛球场、职工心灵驿站、职工书屋、电子阅览室、多媒体教育培训室、职工培训中心、职工影院等核心功能室场，为职工群众提供集教育、文化、体育、生活于一体的综合服务，是广大职工群众的“学校和乐园”。作为党联系职工群众的桥梁纽带，东区街道工人文化宫将始终坚持正确的政治方向，紧紧围绕建设“现代服务高地、美丽中山示范”的目标，立足基层和职工需求，聚焦工会主责主业，突出“公益性、服务性”方向，竭诚为广大职工群众提供全方位优质服务，为推动中山高质量发展贡献力量。</div>
            </div>
          </div>
        </div>
        <div className='pg-culture-palace-content' key={2}>
          <div className='pg-culture-palace-left'>
            {
              sidebarTabs.map(item => <div
                onClick={() => handleChangeActive(item.key)}
                key={item.key}
                className={`pg-culture-palace-tab ${item.key === sidebarActive ? 'active' : ''}`}
              >
                { item.title }
              </div>)
            }
          </div>
          <div className='pg-culture-palace-right'>
            {
              sidebarTabs[sidebarActive - 1].imgs.map(item =>
                item.url ? <div className='pg-culture-palace-img-box' key={item.name}>
                    <div className='pg-culture-palace-img-title'>
                      <span style={{ marginRight: '8px' }}>{ item.name }</span>
                      <span>1/{item.urls.length}</span>
                    </div>
                    <img onClick={() => handlePreview(item)} src={item.url} alt='加载中' />
                  </div>
                : null
              )
            }
          </div>
        </div>
        <div key={3} className='list-img--wrap'>
          {
            list.map((item, index) => {
              return <img className='list-img' key={index} src={item.src} onClick={() => handleClick(item.id)} />
            })
          }
        </div>
        <div key={4} className='pg-culture-palace-room'>
          <img
            className='pg-culture-palace-room-img'
            src='http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/culturePalace/empty.png'
            alt='加载中'
          />
          <div className='pg-culture-palace-room-text'>室场预约已满</div>
        </div>
      </Tabs>
    </div>
  )
}

export default memo(CulturePalace)